import React, { useState, useCallback, useEffect } from 'react';
import 'devextreme/data/odata/store';
import { Button, TabPanel } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import Popup from 'devextreme-react/popup';
import { useNavigate } from 'react-router';
import NuevaCategoria from '../NuevaCategoría/NuevaCategoria';
import NuevosCursos from '../NuevoCurso/NuevoCurso';
import './LibretaTareas.scss';
import AccordionCategorias from '../../components/LibretaTareas_Categorias/LibretaTareas_Categorias';
import AccordionCursos from '../../components/LibretaCursos_Cursos/LibretaCursos_Cursos';
import EditarCategorias from '../NuevaCategoría/EditarCategoria';
import EditarCurso from '../NuevoCurso/EditarCurso';
import { useDispatch, useSelector } from 'react-redux';
import * as lbActions from '../../reduxStore/LibretaTareas/LB_actions';
import { halcoloaderActive, halcoloaderRemove } from '../../contexts/HalcoLoader';

export default function Task() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedTabFromRedux = useSelector((state: any) => state.LibretaTareas.SelectedTab);
    const [NuevaCategoriaVisible, setNuevaCategoriaVisible] = useState<boolean>(false);
    const [visibleEditarCategorias, setVisibleEditarCategorias] = useState<boolean>(false);
    const [visibleEditarCurso, setVisibleEditarCurso] = useState<boolean>(false);
    const [visibleNuevoCurso, setVisibleNuevoCurso] = useState<boolean>(false);
    const [tabIndex, setTabIndex] = useState<number>(selectedTabFromRedux);

    useEffect(() => {
        setTabIndex(selectedTabFromRedux);
    }, [selectedTabFromRedux]);

    const handlePopupHidden = async () => {
        setNuevaCategoriaVisible(false);
        setVisibleEditarCategorias(false);
        setVisibleEditarCurso(false);
        setVisibleNuevoCurso(false);
    }

    const NuevaTarea = async () => {
        try {
            halcoloaderActive();
            dispatch(lbActions.set_tarea_id("-1"));
            dispatch(lbActions.set_tarea_titulo(""));
            dispatch(lbActions.set_tarea_img(""));
            dispatch(lbActions.set_tarea_imgname(""));
            dispatch(lbActions.set_tarea_contenido(""));
            dispatch(lbActions.set_tarea_vencimiento(false));
            dispatch(lbActions.set_tarea_cantidad(0));
            dispatch(lbActions.set_tarea_tiempo(""));
            dispatch(lbActions.set_tarea_secuencia(""));
            dispatch(lbActions.set_tarea_categoria(""));
            dispatch(lbActions.set_tarea_notificacion(false));
            dispatch(lbActions.set_tarea_autoasignacion(false));
            dispatch(lbActions.set_tarea_tipoasignacion(false));
            dispatch(lbActions.set_tarea_segmentacion([]));
            dispatch(lbActions.set_tarea_segmentacionType(false));
            dispatch(lbActions.set_tarea_from(""));
            dispatch(lbActions.set_tarea_to(""));
            dispatch(lbActions.set_tarea_evaluation_id(null));
            dispatch(lbActions.set_tarea_attachments([]));
            dispatch(lbActions.set_tarea_order(10000));
            dispatch(lbActions.set_tarea_tipo_tarea("Onbording"));
            await navigate('/tasks');

            halcoloaderRemove();
        }
        catch (error) {
            notify(error, 'error');
        }
    };

    const NuevoCurso = async () => {
        try {
            halcoloaderActive();
            dispatch(lbActions.set_tarea_id("-1"));
            dispatch(lbActions.set_tarea_titulo(""));
            dispatch(lbActions.set_tarea_img(""));
            dispatch(lbActions.set_tarea_imgname(""));
            dispatch(lbActions.set_tarea_contenido(""));
            dispatch(lbActions.set_tarea_vencimiento(false));
            dispatch(lbActions.set_tarea_cantidad(0));
            dispatch(lbActions.set_tarea_tiempo(""));
            dispatch(lbActions.set_tarea_secuencia(""));
            dispatch(lbActions.set_tarea_categoria(""));
            dispatch(lbActions.set_tarea_notificacion(false));
            dispatch(lbActions.set_tarea_autoasignacion(false));
            dispatch(lbActions.set_tarea_tipoasignacion(false));
            dispatch(lbActions.set_tarea_segmentacion([]));
            dispatch(lbActions.set_tarea_segmentacionType(false));
            dispatch(lbActions.set_tarea_from(""));
            dispatch(lbActions.set_tarea_to(""));
            dispatch(lbActions.set_tarea_evaluation_id(null));
            dispatch(lbActions.set_tarea_attachments([]));
            dispatch(lbActions.set_tarea_order(10000));
            dispatch(lbActions.set_tarea_tipo_tarea("LMS"));
            await navigate('/tasks');

            halcoloaderRemove();
        }
        catch (error) {
            notify(error, 'error');
        }
    };

    const showWindow = (window: string): any => {
        try {
            switch (window) {
                case "Editar_Categoria":
                    setVisibleEditarCategorias(true);
                    break;
                case "Nueva_Categoria":
                    setNuevaCategoriaVisible(true);
                    break;
                case "Editar_Curso":
                    setVisibleEditarCurso(true);
                    break;
                case "Nuevo_Curso":
                    setVisibleNuevoCurso(true);
                    break;
            }
        }
        catch (error) {
            notify(error, 'error');
        }
    }

    const renderNuevaCategoria = useCallback(() => (
        <div style={{ margin: "40px" }}>
            <NuevaCategoria handlePopupHidden={handlePopupHidden}></NuevaCategoria>
        </div>), [NuevaCategoria]);
    const renderEditarCategorias = () => {
        return <EditarCategorias></EditarCategorias>
    }

    const renderEditarCurso = () => {
        return <EditarCurso></EditarCurso>
    }

    const tabs = [
        {
            title: 'Onbording',
            content: (
                <div>
                    <div style={{ display: "flex", margin: "20px 0px 0px 0px" }}>
                        <Button
                            text='Nueva Tarea'
                            onClick={NuevaTarea}
                            className='btnNuevaTarea'
                        ></Button>
                        <Button
                            text='Nueva categoría'
                            onClick={() => showWindow("Nueva_Categoria")}
                            className='btnNuevaCategoria'
                        ></Button>
                        <Button
                            text='Categorías'
                            onClick={() => showWindow("Editar_Categoria")}
                            className='btnCategorias'
                        ></Button>
                    </div>
                    <AccordionCategorias></AccordionCategorias>
                </div>
            )
        },
        {
            title: 'Cursos',
            content: (
                <div>
                    <div style={{ display: "flex", margin: "20px 0px 0px 0px" }}>
                        <Button
                            text='Nueva Clase'
                            onClick={NuevoCurso}
                            className='btnNuevaClase'
                        ></Button>
                        <Button
                            text='Nuevo Curso'
                            onClick={() => showWindow("Nuevo_Curso")}
                            className='btnNuevoCurso'
                        ></Button>
                        <Button
                            text='Cursos'
                            onClick={() => showWindow("Editar_Curso")}
                            className='btnCursos'
                        ></Button>
                    </div>              
                    <AccordionCursos></AccordionCursos>
                </div>
            )
        }
    ];

    const TitleClick = (e: { [key: string]: any }) => {
        try {
            halcoloaderActive();
            const newTabIndex = e.component.option('selectedIndex');
            setTabIndex(newTabIndex);
            dispatch(lbActions.set_tarea_selected_tab(newTabIndex));
            halcoloaderRemove();
        }
        catch (error) {
            notify(error, "error");
        }
    }

    return (
        <React.Fragment>
            <div className={'content-block dx-card responsive-paddings'} style={{ margin: "30px auto 30px auto", width: "95%" }}>
                <div style={{ display: "flex" }}>
                    <TabPanel
                        items={tabs}
                        deferRendering={true}
                        animationEnabled={true}
                        swipeEnabled={true}
                        selectedIndex={tabIndex}
                        showNavButtons={true}
                        itemTitleRender={(data) => <span>{data.title}</span>}
                        onTitleClick={(e) => TitleClick(e)}
                        itemRender={(data) => data.content}
                        width={"100%"}
                    />
                </div>
            </div>
            <Popup
                width={"70rem"}
                height={"23rem"}
                className='winNuevaCategoría'
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={NuevaCategoriaVisible}
                onHiding={() => handlePopupHidden()}
                contentRender={() => renderNuevaCategoria()}
                showCloseButton={false}
                resizeEnabled={true}
            />
            <Popup
                width={"80%"}
                height={"78%"}
                className='winEditarCategoria'
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={visibleEditarCategorias}
                onHiding={() => handlePopupHidden()}
                contentRender={() => renderEditarCategorias()}
                showCloseButton={false}
                resizeEnabled={false}
            />
            <Popup
                key={visibleNuevoCurso ? "open" : "closed"}
                width={"70rem"}
                height={"auto"}
                className='winNuevoCurso'
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={visibleNuevoCurso}
                onHiding={() => handlePopupHidden()}
                contentRender={() =>
                    <NuevosCursos
                        handlePopupHidden={handlePopupHidden}
                        base_64_image=''
                        foto_curso=''
                        titulo_curso=''
                        nuevo_curso={false}
                        visible_audiencia={false}
                        visible_curso_generado={false}
                    ></NuevosCursos>
                }
                showCloseButton={false}
                resizeEnabled={true}
            />
            <Popup
                width={"80%"}
                height={"78%"}
                className='winEditarCurso'
                showTitle={false}
                dragEnabled={false}
                hideOnOutsideClick={true}
                visible={visibleEditarCurso}
                onHiding={() => handlePopupHidden()}
                contentRender={() => renderEditarCurso()}
                showCloseButton={false}
                resizeEnabled={false}
            />
        </React.Fragment>
    )
}